import { render, staticRenderFns } from "./成交公告详情.vue?vue&type=template&id=6f239bb5&scoped=true"
import script from "./成交公告详情.vue?vue&type=script&lang=js"
export * from "./成交公告详情.vue?vue&type=script&lang=js"
import style0 from "./成交公告详情.vue?vue&type=style&index=0&id=6f239bb5&prod&lang=css"
import style1 from "./成交公告详情.vue?vue&type=style&index=1&id=6f239bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f239bb5",
  null
  
)

export default component.exports